import React, { FC } from 'react';
import {
  Label,
  useFiltersLabel,
  getOptionsWithEmptyOption,
  FiltersNameEnum,
  SelectOption,
  FilterDrawerType,
} from '@blocs.filter';
import { RangeSelector } from '../../../shared/components';
import { StyledFormikSelect } from '../../../shared/styles';
import { RangeList, RangeItem } from '../ClothingSizesStyles';

type Props = {
  showInImperial: boolean;
  type: FilterDrawerType;
  optionsList: { [key: string]: SelectOption[] };
};

const ClothingSizesWomen: FC<Props> = ({ showInImperial, type, optionsList }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);
  const {
    dressSizeOptions,
    bustsOptions,
    underBustsOptions,
    cupsOptions,
    hipsOptions,
    femalePantsSizeOptions,
    femaleTshirtSizesOptions,
    femaleShoeSizeOptions,
    shoeModifierOptions,
  } = optionsList;

  return (
    <RangeList>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.dress}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.dress]}
          options={dressSizeOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.bust}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.bust]}
          options={bustsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.underbust}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.underbust]}
          options={underBustsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.cup}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.cup]}
          options={cupsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.hip}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.hip]}
          options={hipsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.womenPants}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.womenPants]}
          options={femalePantsSizeOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.womenTShirt}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.womenTShirt]}
          options={femaleTshirtSizesOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.womenShoes}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.womenShoes]}
          options={femaleShoeSizeOptions}
        />
      </RangeItem>
      <RangeItem>
        <Label>{filtersLabelOfAudience[FiltersNameEnum.womenShoeWidth]}</Label>
        <StyledFormikSelect
          saveAsOption
          name={FiltersNameEnum.womenShoeWidth}
          size="small"
          options={getOptionsWithEmptyOption(shoeModifierOptions)}
        />
      </RangeItem>
    </RangeList>
  );
};

export default ClothingSizesWomen;
